import React, { useEffect, useRef } from 'react';

import WebGL from '.';
import { Wrapper } from './styles';

// Fullscreen Canvas Layer
// Use only to start the WebGL and display the canvas

export const WEB_GL_LAYER_ID = 'WEB_GL_LAYER_ID';

const WebGLLayer = () => {
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        try {
            WebGL.setDOM(wrapperRef.current, true);
            if (WebGL.first) {
                WebGL.start(true, false, false, 0x090719);
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
        }
    }, []);

    return <Wrapper id={WEB_GL_LAYER_ID} ref={wrapperRef} />;
};

export default WebGLLayer;
